import { render, staticRenderFns } from "./ArtworksNFT.vue?vue&type=template&id=5ca4ca58&scoped=true"
import script from "./ArtworksNFT.vue?vue&type=script&lang=js"
export * from "./ArtworksNFT.vue?vue&type=script&lang=js"
import style0 from "./ArtworksNFT.vue?vue&type=style&index=0&id=5ca4ca58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4ca58",
  null
  
)

export default component.exports